import { login, logout, getUserInfo } from '@/api/user'
// import { setToken, getToken, setTagNavListInLocalstorage } from '@/libs/util'
import { setToken, getToken } from '@/libs/util'
import { Message } from 'view-design'

export default {
  state: {
    username: '',
    userId: '',
    shopId: '',
    tenantId: '',
    avatar: '',
    avatarImgPath: '',
    token: getToken(),
    access: '',
    userData: sessionStorage.userData
      ? JSON.parse(sessionStorage.userData)
      : '', // 账号信息

    hasGetInfo: false
  },
  mutations: {
    setAvatar(state, avatarPath) {
      state.avatarImgPath = avatarPath
    },
    setUserId(state, id) {
      state.userId = id
      localStorage.userId = id
    },
    setshopId(state, shopId) {
      state.shopId = shopId
      localStorage.shopId = shopId
    },
    settenantId(state, tenantId) {
      state.tenantId = tenantId
      localStorage.tenantId = tenantId
    },
    setUserName(state, name) {
      state.username = name
    },
    setUserData(state, userData) {
      state.userData = userData
      localStorage.userData = JSON.stringify(userData)
    },
    setAccess(state, access) {
      state.access = access
    },
    setAvatar(state, avatar) {
      state.avatar = avatar
    },
    setToken(state, token) {
      state.token = token
      setToken(token)
    },
    setHasGetInfo(state, status) {
      state.hasGetInfo = status
    },
    setStaffName(state, staffName) {
      state.staffName = staffName
      // console.log(staffName)
      localStorage.staffName = staffName
    }
  },
  getters: {},
  actions: {
    // 登录
    handleLogin({ commit }, { username, password, deviceId, autotest }) {
      username = username.trim()
      return new Promise((resolve, reject) => {
        login({
          username,
          password,
          deviceId,
          autotest
        })
          .then(res => {
            // console.log(res)
            const data = res.data

            // 登录信息
            localStorage.userdetails = JSON.stringify(data.userdetails)
            // 联盟信息
            localStorage.userdetails_leagueInfo = JSON.stringify(
              data.userdetails.leagueInfo
            )
            // 租户信息
            localStorage.userdetails_tenantInfo = JSON.stringify(
              data.userdetails.tenantInfo
            )
            // 权限信息
            let access =
              data.userdetails.resourceVOS &&
              data.userdetails.resourceVOS.map(item => item.name)
            let siderList = [] // 菜单数组
            let btnList = [] // 菜单数组
            data.userdetails.resourceVOS.forEach(item => {
              if (item.resourceType == 1) {
                siderList.push(item.name)
              } else if (item.resourceType == 2) {
                btnList.push(item.name)
              }
            })
            localStorage.setItem('siderList', JSON.stringify(siderList))
            localStorage.setItem('btnList', JSON.stringify(btnList))
            commit('setAccess', access)
            commit('setUserId', data.userdetails.userInfo.id)
            // commit('setshopId', data.userdetails.tenantInfo.shopId)
            // commit('settenantId', data.userdetails.tenantInfo.tenantId)
            // commit('setAvatar', data.avatar)
            commit('setUserData', data.userdetails.userInfo)

            commit('setToken', data.access_token)
            // sessionStorage.setItem('token', data.access_token)
            // commit('setUserName', username)
            commit('setStaffName', data.userdetails.userInfo.staffName)
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 退出登录
    handleLogOut({ state, commit }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit('setToken', '')
            commit('setAccess', [])
            sessionStorage.clear()
            localStorage.clear()
            // setTagNavListInLocalstorage([])
            resolve()
          })
          .catch(err => {
            reject(err)
          })
        // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
        // commit('setToken', '')
        // commit('setAccess', [])
        // resolve()
      })
    }
    // 获取用户相关信息
    // getUserInfo({ state, commit }) {
    //   return new Promise((resolve, reject) => {
    //     try {
    //       let token = state.token || localStorage.getItem('token')
    //       getUserInfo(token)
    //         .then(res => {
    //           const data = res.data
    //  access权限数组(菜单+按钮)
    // let access =
    //   data.resourceVOS && data.resourceVOS.map(item => item.name)
    // let siderList = [] // 菜单数组
    // let btnList = [] // 菜单数组
    // data.resourceVOS.forEach(item => {
    //   if (item.resType == 1) {
    //     siderList.push(item.name)
    //   } else if (item.resType == 2) {
    //     btnList.push(item.name)
    //   }
    // })
    // localStorage.setItem('siderList', JSON.stringify(siderList))
    // localStorage.setItem('btnList', JSON.stringify(btnList))
    // commit('setAccess', access)
    // commit('setUserId', data.id)
    // commit('setshopId', data.shopId)
    // commit('settenantId', data.tenantId)
    // commit('setAvatar', data.avatar)
    // commit('setUserData', data)
    // commit('setUserName', data.username)
    // sessionStorage.setItem('avatar', data.avatar)
    //         resolve(data)
    //       })
    //       .catch(err => {
    //         reject(err)
    //       })
    //   } catch (error) {
    //     reject(error)
    //   }
    // })
    // }
  }
}
